// removed by extract-text-webpack-plugin
module.exports = {"menuItemLabel":"_1F4y1qO2pI2j_Zoh"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Menu/MenuItemLabel.pcss
// module id = 476
// module chunks = 1